import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import AddCustomerService from '@/components/commons/AddCustomerService';
import Head from '@/components/commons/Head';
import { useRouter } from 'next/navigation';

const ToolsContent = () => {
  const t = useTranslations();
  const currentLocale = useLocale();
  const router = useRouter();

  return (
    <div className="w-full">
      <Head
        title={'免费评估,CRS打分,移民留学打分表,移民指南'}
        description={
          '星环移民，专注加拿大移民和留学十余载，擅长量身定制方案，提供高性价比服务，成功率居行业领先水平。旗下拥有多位全职的ICCRC认证的「加拿大持牌移民顾问」、教育专家和职业培训导师，专业办理加拿大移民、留学、游学、夏令营、教育等服务，提供顾问咨询、签证办理、学校申请、就业指导、财税规划及新移民安家落地、置业创业等一条龙服务，对于解决各种签证、留学、移民疑难问题有丰富经验与成功案例。'
        }
        keywords="移民,海外移民,加拿大移民,全球移民,移民咨询,移民公司,移民中介,星环移民"
      />
      {/* 免费评估 */}
      <div
        style={{
          backgroundImage: 'url(/images/tools/bg.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        className="mb-[2.496vw] flex h-auto w-full flex-row items-center justify-center pb-[3.12vw] pt-[3.64vw] max-md:mb-6 max-md:flex-col max-md:px-[30px]"
      >
        <div className="mr-[9.672vw] flex w-[33.696vw] flex-col items-start justify-center max-md:mb-6 max-md:mr-0 max-md:w-full">
          <div className="mb-[2.912vw] flex flex-row items-center justify-start max-md:mb-6">
            <div className="mr-[1.04vw] h-[94px] w-[6px] bg-[#2A2B45] max-md:h-[40px] max-md:w-1"></div>
            <div>
              <h1 className="mb-[0.832vw] text-[2.184vw] font-semibold leading-[2.184vw] text-[#2A2B45] max-md:text-base">
                <span className="text-[#EE8408]">{t('Tools.free')}</span>
                {t('Tools.assessment')}
              </h1>
              <h1 className="font-black leading-[1.872] text-[#2A2B45] text-[1.872] opacity-20 max-md:text-sm">
                {t('Tools.assessmentEnglish')}
              </h1>
            </div>
          </div>
          <h5 className="mb-[1.664vw] text-[0.936vw] font-normal text-[#212136] max-md:text-xs">
            {t('Tools.assessmentContent1')}
          </h5>
          {/* <h5 className="text-[0.936vw] font-normal text-[#212136] max-md:text-xs">{t('Tools.assessmentContent2')}</h5> */}
        </div>
        <div className="flex flex-row items-center justify-center max-md:w-full">
          <div
            className="mb-[3.744vw] mr-[0.624vw] box-border flex h-[20.8vw] w-[15.6vw] cursor-pointer flex-col items-start justify-between rounded-bl-[20px] rounded-tl-[20px] bg-[#A42525] py-[1.04vw] max-md:mb-[27px] max-md:mr-2 max-md:h-[148px] max-md:w-[110px] max-md:rounded-bl-xl max-md:rounded-tl-xl max-md:py-[7px]"
            onClick={() => {
              window.open(process.env.NEXT_PUBLIC_WEBSITE + '/移民评估表', '_blank');
            }}
          >
            <Image
              src={'/images/tools/icon1.png'}
              width={136}
              height={179}
              className={`h-auto ${currentLocale === 'zh' ? 'w-[7.072vw]' : 'w-[6.072vw]'} max-md:w-[50px]`}
              alt="icon"
            />
            <div className="box-border flex w-full flex-row items-center justify-end px-[1.248vw]">
              <div className="flex flex-col items-end justify-start">
                <div className="mb-[1.248vw] text-right text-[1.56vw] font-medium leading-[1.56vw] text-white max-md:text-[14px] max-md:leading-[14px]">
                  {t('Tools.immigrationAssessment')}
                </div>
                <div className="text-[0.936vw] leading-[1.248vw] text-white opacity-60 max-md:text-[10px] max-md:leading-[10px]">
                  {t('Tools.immigration')}
                </div>
                <div className="mb-[1.04vw] text-[0.936vw] leading-[1.248vw] text-white opacity-60 max-md:text-[10px] max-md:leading-[10px]">
                  {t('Tools.assessmentForm')}
                </div>
                <Image
                  src={'/images/tools/icon3.png'}
                  width={44}
                  height={44}
                  className="size-[2.288vw] cursor-pointer max-md:size-[16px]"
                  alt="icon"
                />
              </div>
            </div>
          </div>
          <div
            className={`mt-[3.744vw] flex h-[20.8vw] w-[15.6vw] cursor-pointer flex-col items-start justify-between rounded-br-[20px] rounded-tr-[20px] bg-[#3A3EA2] max-md:rounded-br-xl max-md:rounded-tr-xl ${currentLocale === 'zh' ? 'pb-[1.352vw] pt-[2.08vw]' : 'py-[1.04vw]'} max-md:mb-[27px] max-md:mr-2 max-md:h-[148px] max-md:w-[110px] max-md:py-[7px]`}
            onClick={() => {
              window.open(process.env.NEXT_PUBLIC_WEBSITE + '/留学评估表', '_blank');
            }}
          >
            <Image
              src={'/images/tools/icon2.png'}
              width={136}
              height={179}
              className={`h-auto ${currentLocale === 'zh' ? 'w-[7.072vw]' : 'w-[6.072vw]'} max-md:w-[50px]`}
              alt="icon"
            />
            <div className="box-border flex w-full flex-row items-center justify-end px-[1.248vw] max-md:px-[6px]">
              <div className="flex flex-col items-end justify-start">
                <div className="mb-[1.248vw] text-right text-[1.56vw] font-medium leading-[1.56vw] text-white max-md:text-[14px] max-md:leading-[14px]">
                  {t('Tools.studyAbroadAssessment')}
                </div>
                <div className="text-[0.936vw] leading-[1.248vw] text-white opacity-60 max-md:text-[10px] max-md:leading-[10px]">
                  {t('Tools.studyAbroad')}
                </div>
                <div className="mb-[1.04vw] text-[0.936vw] leading-[1.248vw] text-white opacity-60 max-md:text-[10px] max-md:leading-[10px]">
                  {t('Tools.assessmentForm')}
                </div>
                <Image
                  src={'/images/tools/icon3.png'}
                  width={44}
                  height={44}
                  className="size-[2.288vw] cursor-pointer max-md:size-[16px]"
                  alt="icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 重要资源与工具 */}
      <div className="mb-[5.824vw] w-full max-md:mb-6">
        <div className="box-border w-full px-[10.4vw] max-md:px-[30px]">
          <h2 className="mb-[1.04vw] text-[2.08vw] font-medium text-[#2A2B45] max-md:mb-2 max-md:text-base max-md:leading-[16px]">
            {t('Tools.resourcesTools')}
          </h2>
          <h2 className="mb-[3.12vw] text-[1.872vw] font-black leading-[1.872vw] text-[#2A2B45] opacity-20 max-md:mb-4 max-md:text-sm max-md:leading-[14px]">
            {t('Tools.resourcesToolsEnglishText')}
          </h2>
        </div>
        <div className="box-border grid w-full grid-cols-3 gap-x-[3.016vw] gap-y-[1.56vw] px-[15.6vw] max-md:grid-cols-1 max-md:px-[30px]">
          {[{ url: '/移民评估表' }, { url: '/留学评估表' }, { url: '/tools/crs' }].map((item, index) => {
            return (
              <div
                key={index}
                className={`flex h-[8.32vw] ${item.url ? 'cursor-pointer' : ''} flex-col items-center justify-center bg-[#3a3ea21a] max-md:h-[60px]`}
                onClick={() => {
                  if (item.url) {
                    if (item.url === '/tools/crs') {
                      router.push(item.url);
                      return;
                    }
                    window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                  }
                }}
              >
                <h3 className="mb-[0.832vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#3C3D5B] max-md:mb-1 max-md:text-sm">
                  {t(`Tools.resourcesToolsCard1Title${index + 1}` as any)}
                </h3>
                <h3 className="text-[0.936vw] font-normal leading-[0.936vw] text-[#3C3D5B] max-md:text-xs max-md:leading-[12px]">
                  {t(`Tools.resourcesToolsCard1EnglishTitle${index + 1}` as any)}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
      {/* 移民常用工具 */}
      <div className="mb-[4.992vw] w-full">
        <div className="box-border w-full px-[10.4vw]">
          <h2 className="mb-[1.04vw] text-[2.08vw] font-medium text-[#2A2B45] max-md:mb-2 max-md:text-base max-md:leading-[16px]">
            {t('Tools.toolsForImmigration')}
          </h2>
          <h2 className="mb-[3.12vw] text-[1.872vw] font-black leading-[1.872vw] text-[#2A2B45] opacity-20 max-md:mb-4 max-md:text-sm max-md:leading-[14px]">
            {t('Tools.toolsForImmigrationEnglishText')}
          </h2>
        </div>
        <div className="box-border grid w-full grid-cols-3 gap-x-[3.016vw] gap-y-[1.56vw] px-[15.6vw] max-md:grid-cols-1 max-md:px-[30px]">
          {[
            { url: '/immigration/language-test-equivalent-chart/' },
            { url: '/加拿大「持牌移民顾问」是怎样炼成的-远离非法/' },
          ].map((item, index) => {
            return (
              <div
                key={index}
                className="flex h-[8.32vw] cursor-pointer flex-col items-center justify-center bg-[#3a3ea21a] max-md:h-[60px]"
                onClick={() => {
                  if (item.url) {
                    window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                  }
                }}
              >
                <h3 className="mb-[0.832vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#3C3D5B] max-md:mb-1 max-md:text-sm">
                  {t(`Tools.resourcesToolsCard2Title${index + 1}` as any)}
                </h3>
                <h3 className="text-[0.936vw] font-normal leading-[0.936vw] text-[#3C3D5B] max-md:text-xs max-md:leading-[12px]">
                  {t(`Tools.resourcesToolsCard2EnglishTitle${index + 1}` as any)}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
      {/* 添加客服 */}
      <AddCustomerService />
    </div>
  );
};

export default ToolsContent;
